import Router from 'bpm-router';

import { bindEvents, offset } from '../../assets/js/helpers';

import App from '../../assets/js/app';

import AnimationController from '../../assets/js/controller/animation';
import PageController from '../../assets/js/controller/page';
import ScrollController from '../../assets/js/controller/scroll';
import SectionController from '../../assets/js/controller/section';


const selector = 'next-chapter';

export default class NextChapter {

	constructor(section) {
		this.el = {
			section,
			background: section.querySelector(`.${selector}__background`),
			svgParallax: section.querySelector(`.${selector}__svg-parallax`),
			fillSVGs: section.querySelectorAll(`.${selector}__svg-fill svg`)
		};

		this.el.video = document.createElement('video');
		this.el.video.muted = true;
		this.el.video.playsinline = true;
		this.el.video.loop = true;
		this.el.video.setAttribute('muted', 'muted');
		this.el.video.setAttribute('playsinline', 'playsinline');
		this.el.video.setAttribute('loop', 'loop');
		this.el.video.src = `${this.el.background.dataset.videoSource}-${(window.innerWidth < 1024 ? 50 : 100)}.mp4`;
		this.el.background.appendChild(this.el.video);

		this.viewport = 0;
		this.height = 0;
		this.offset = 0;

		this.position = 0;
		this.scale = 0;

		this.holding = false;
		this.continue = false;

		this.events = bindEvents(this);

		this.addEventListeners();
		this.measure();
		this.start();
	}

	static get selector() {
		return selector;
	}

	measure() {
		this.viewport = window.innerHeight;
		this.height = this.el.section.offsetHeight;
		this.offset = offset.top(this.el.section);
	}

	update(position) {
		const max = Math.round(this.height / 2);
		let p = Math.round(max - (position.current + this.viewport - this.offset) / 2);
		if (p > max) p = max;
		if (p !== this.position) {
			this.position = p;
			this.scale = 1 + (p / max * 0.5);
			return true;
		}
	}

	render() {
		this.el.video.style.transform = `translate3d(0,${-this.position}px,0) scale3d(${this.scale},${this.scale},1)`;
		this.el.svgParallax.style.transform = `translate3d(0,${-this.position}px,0)`;
	}

	start() {
		this.animation = AnimationController.set({
			update: this.update.bind(this),
			render: this.render.bind(this)
		}, 'next chapter');
	}

	pause() {
		AnimationController.clear(this.animation);
	}

	_onWindowLoad() {
		this.measure();
	}

	_onWindowResize() {
		this.measure();
	}

	_onDocumentMouseUp() {
		if (this.holding) {
			this.holding = false;
			if (!this.continue) this.el.section.classList.remove('fill-svgs');
		}
	}

	_onSectionReveal() {
		this.measure();
		this.el.video.currentTime = 0;
		this.el.video.play();
	}

	_onSectionMouseDown() {
		this.holding = true;
		this.el.section.classList.add('fill-svgs');
		ScrollController.scrollTo(Math.round(this.offset - (this.viewport - this.height)));
	}

	_onSectionClick() {
		if (App.touch) {
			this.holding = true;
			this.el.section.classList.add('fill-svgs');
			ScrollController.scrollTo(Math.round(this.offset - (this.viewport - this.height)));
		}
	}

	_onfillSVGTransitionEnd(e) {
		if (!this.continue && this.holding && (e.propertyName === 'transform' || e.propertyName === '-webkit-transform')) {
			this.continue = true;
			this.el.section.classList.add('changing-chapter');
			ScrollController.scrollTo(Math.round(this.offset - (this.viewport - this.height)));
			setTimeout(() => SectionController.globals['fixed-header'].hide(), 1000);
			setTimeout(() => {
				const next = PageController.active + 1;
				const index = next < 10 ? `0${next}` : next;
				App.transition = false;
				Router.navigate(`/${index}`);
			}, 2000);
		}
	}

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowResize);

		document.addEventListener('mouseup', this.events._onDocumentMouseUp);

		this.el.section.addEventListener('reveal', this.events._onSectionReveal);
		this.el.section.addEventListener('mousedown', this.events._onSectionMouseDown);
		this.el.section.addEventListener('click', this.events._onSectionClick);
		for (const fs of this.el.fillSVGs) fs.addEventListener('transitionend', this.events._onfillSVGTransitionEnd);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowResize);

		document.removeEventListener('mouseup', this.events._onDocumentMouseUp);

		this.el.section.removeEventListener('reveal', this.events._onSectionReveal);
		this.el.section.removeEventListener('mousedown', this.events._onSectionMouseDown);
		this.el.section.removeEventListener('click', this.events._onSectionClick);
		for (const fs of this.el.fillSVGs) fs.removeEventListener('transitionend', this.events._onfillSVGTransitionEnd);
	}

	destroy() {
		if (this.continue) App.sendCoverVideo(this.el.video);
		this.pause();
		this.removeEventListeners();
	}

}
